/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Czech
export default {
    'fabric.atlassianSwitcher.switchTo': 'Přepnout na',
    'fabric.atlassianSwitcher.switchToTooltip': 'Přepnout na…',
    'fabric.atlassianSwitcher.recent': 'Nedávné',
    'fabric.atlassianSwitcher.more': 'Více',
    'fabric.atlassianSwitcher.try': 'Vyzkoušejte to',
    'fabric.atlassianSwitcher.manageList': 'Spravovat seznam',
    'fabric.atlassianSwitcher.jiraProject': 'Projekt Jira',
    'fabric.atlassianSwitcher.confluenceSpace': 'Prostor Confluence',
    'fabric.atlassianSwitcher.people': 'Lidé',
    'fabric.atlassianSwitcher.administration': 'Správa',
    'fabric.atlassianSwitcher.discoverMore': 'Objevte více',
    'fabric.atlassianSwitcher.errorHeading': 'Něco se pokazilo',
    'fabric.atlassianSwitcher.errorText': 'Tyto chyby zaznamenáváme, ale nebojte se nás kontaktovat, pokud obnovení stránky problém nevyřeší.',
    'fabric.atlassianSwitcher.errorImageAltText': 'Rozbitý robot a několik lidí se ho snaží opravit.',
    'fabric.atlassianSwitcher.expand': 'Rozbalit',
};
//# sourceMappingURL=cs.js.map